<template>
  <div id="app">
    <Header v-if="showHeader" />
    <router-view></router-view>
  </div>
</template>

<script>
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: { Header },
  computed: {
    showHeader() {
      // Header on every screen except the login entry point
      return this.$route.name && this.$route.name !== 'Login'
    }
  }
}
</script>

<style>
/* Global base lives in src/assets/theme.css.
   App shell only sets the full-height painted surface. */
html, body, #app {
  min-height: 100vh;
}
#app {
  font-family: var(--font-ui);
  color: var(--ink);
  background: var(--turf-bg);
}
</style>